<template>
  <!--彈出視窗-->
  <v-dialog v-model="isVisible" persistent :max-width="width">
    <v-card>
      <v-card-title class="headline">
        {{ title }}
      </v-card-title>
      <v-card-text>
        <div
          ref="printRange" class="page" v-if="itemInfo"
        >
          <div style="text-align:center; line-height:28pt">
            <div class="header">
              取貨人：{{ customName }}
            </div>
          </div>
          <div style="text-align:center; line-height:28pt">
            <div class="header">
              屈臣氏{{ shopName }}門市
            </div>
          </div>
          <div style="line-height:14pt">
            <div class="title">訂貨編號：{{ itemInfo.orderId }}</div>
          </div>
          <div>
            <div class="title">手機後三碼：{{ lastPhone }}</div>
          </div>
          <div>
            <span class="title">消費金額：{{ itemInfo.price }}</span>
          </div>
          <div><img src="@/assets/images/logoInfo.png" /></div>
          <div style="background: black; width: 376px;height: 1px;"></div>
          <div style="text-align:center; line-height:24pt">
            <div class="header">
              店家存根
            </div>
          </div>
          <div style="width: 283.464pt;">
            <img
              src="@/assets/images/qrCode.png"
              width="96"
              height="96"
              alt=""
              style="display:block; margin:auto;"
            />
          </div>
          <div style="line-height:24pt">
            <span class="title">應付金額： </span
            ><span class="title"
              >{{itemInfo.price }}
              </span
            ><span class="title">元</span>
          </div>
          <table
            cellspacing="0"
            cellpadding="0"
            class="TableGrid"
            style="width:232.25pt; margin: 0 auto; border:0.75pt solid #000000; border-collapse:collapse"
          >
            <tr style="height:12.95pt">
              <td
                style="width:104.95pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single; -aw-border-right:0.5pt single"
              >
                <div style="text-align:center; line-height:24pt">
                  <div class="title">門市簽名</div>
                </div>
              </td>
              <td
                style="width:104.95pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single; -aw-border-left:0.5pt single"
              >
                <div style="text-align:center; line-height:24pt">
                  <div class="title">消費者簽收</div>
                </div>
              </td>
            </tr>
            <tr style="height:61.85pt">
              <td
                style="width:104.95pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-right:0.5pt single; -aw-border-top:0.5pt single"
              >
                <p style="line-height:24pt">
                  <span
                    style="font-family:微軟正黑體; font-size:14pt; font-weight:bold; -aw-import:ignore"
                    >&#xa0;</span
                  >
                </p>
              </td>
              <td
                style="width:104.95pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-left:0.5pt single; -aw-border-top:0.5pt single"
              >
                <p style="line-height:24pt">
                  <span
                    style="font-family:微軟正黑體; font-size:14pt; font-weight:bold; -aw-import:ignore"
                    >&#xa0;</span
                  >
                </p>
              </td>
            </tr>
          </table>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="#ffb128" dark text @click="cancelEvent">取消</v-btn>
        <v-btn color="#0BA7A3" dark text @click="confirmEvent()">列印</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: "AlertView",
  props: {
    visible: Boolean,
    title: String,
    item: Object,
  },
  data() {
    return {
      width: "60%",
      dates: [
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substring(0, 10),
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substring(0, 10),
      ],
      showDateMenu: false,
      shippingDate: "",
      shippingNumber: "",
    };
  },
  created() {},
  computed: {
    isVisible() {
      return this.visible;
    },
    itemInfo() {
      return this.item;
    },
    lastPhone() {
      return this.item.phone.slice(-3);
    },
    customName(){
      if(this.item) {
        return  this.item.customName.substring(0, 1) + 'X' + this.item.customName.substring(1 + 1)
      } else {
        return '';
      }
    },
    shopName(){
      return this.item.shopName.replace(this.item.shopNo, '');
    }
  },
  methods: {
    cancelEvent() {
      this.$emit("cancelEvent");
    },
    confirmEvent() {
      // this.isVisible = false;
      console.log(``);
      const content = this.$refs.printRange.innerHTML;
      const newPage = window.open("", "", " height: 425.196pt; width: 283.464pt;");
      newPage.document.write(content);
      newPage.print();
      this.$emit("cancelEvent");
    },
  },
};
</script>

<style scoped>
.page{
  height: 425.196pt; width: 283.464pt; border-color: black; border-width: 1.5px;border-style:solid;
}
.header {
  font-family: 微軟正黑體;
  font-size: 22pt;
  font-weight: bold;
  color: black;
}
.title {
  font-family: 微軟正黑體;
  font-size: 14pt;
  font-weight: bold;
  color: black;
}
@media print {
  .page {
    margin: 0;
    border: initial;
    border-radius: initial;
    box-shadow: initial;
    page-break-after: always;
  }
}
</style>
